// extracted by mini-css-extract-plugin
export default {"content":"SpecificTeamMemberView_content__SSft2"};